import { Pipe, PipeTransform } from "@angular/core";
import { ProductViewModelBase, ShoppingCartViewModel } from "src/domain/client";

@Pipe({
  name: "productAddable",
})
export class ProductAddablePipe implements PipeTransform {
  transform(
    product: ProductViewModelBase,
    shoppingCart: ShoppingCartViewModel,
    quantity = 1,
  ): boolean {
    const shoppingCartItem = shoppingCart.shoppingCartItems?.find(
      (_) =>
        _.product?.productId != null &&
        _.product?.productId === product.productId,
    );

    if (shoppingCartItem) {
      quantity = (shoppingCartItem.quantity ?? 0) + quantity;
    } else if (
      product.minimumQuantity != null &&
      quantity < product.minimumQuantity
    ) {
      quantity = product.minimumQuantity;
    }

    return (
      (!product.maximumQuantity || quantity <= product.maximumQuantity) &&
      (!product.minimumQuantity || quantity >= product.minimumQuantity)
    );
  }
}
